// Vendors
import React from 'react';
import { Facet } from '..';

const facets = ['pa_product-type', 'pa_product_cat', 'pa_software'];
const facetMap = new Map([
  ['pa_product-type', 'Type'],
  ['pa_product_cat', 'Category'],
  ['pa_software', 'Software']
]);

const FacetList = () =>
  facets.map((facet) => {
    const title = facetMap.get(facet);
    const attribute = facet;

    return (
      <Facet key={facet} id={facet} title={title} attribute_name={attribute} />
    );
  });

export default FacetList;
